import React, { useRef, useEffect } from 'react';

import { clickLegal } from '@wetransfer/transfer/modules/consent-manager/tracker';
import I18n from '@wetransfer/transfer/modules/i18n';

export function CcpaLegalText() {
  const element = useRef(null);
  const legalPageHref = '/legal/manage-cookies';

  useEffect(() => {
    const legalLinks = element.current.querySelectorAll(
      `a[href="${legalPageHref}"]`
    );

    if (legalLinks) {
      Array.from(legalLinks).forEach((legalLink) => {
        legalLink.onclick = clickLegal;
      });
    }
  }, [element]);

  const content = {
    text: {
      __html: I18n.t('transfer.consent-manager.ccpa-body', {
        href: legalPageHref,
      }),
    },
  };

  return (
    <div className="" ref={element}>
      <div
        className="ccpa-preferences__text"
        dangerouslySetInnerHTML={content.text}
      />
    </div>
  );
}
